import {useParams} from "react-router-dom";
import fetchServerCertificate from "../globalMethods/serverCertificate";
import axios from "axios";
import {RunnerPlayer} from "./runnerPlayer";
import {useEffect, useState} from "react";
import { getServerEndPoint} from "./webEndPoint";
import {
    getChannelLocalToken, getChannelLocalTokenAdswitched,
    getIsoChannelLocalToken,
    getLogoURL,
    isPlayStationBrowser,
    isWindowEdge
} from "../globalMethods/utils";
import {getConfigsDrm, getLicence, isSafari} from "../globalMethods/drmConfigs";
import SimpleBackdrop from "./background";
import {valideLogin} from "../login/UserService";
import {getSavedBarcode} from "../globalMethods/myConfig";
import userSessionChecker from "./check/checker";
import ConnectionBlockedPage from "./check/checkBlockagePage";

export default function  VideoPlayer  ({ }){

    let params = useParams()

    const [isBlocked, setIsBlocked] = useState(false);

    const [userCode, setUserCode] = useState(getSavedBarcode());





    const [loading, setLoading] = useState(true)
    const [configs, setConfigs] = useState({})
    const [mdp, setMdp] = useState("")
    const [userProfiles, setUserProfiles] = useState({})
    const [events, setEvents] = useState([])
    const [showDrawer, setShowDrawer] = useState(false)

    const[channelLogo, setChannelLogo] = useState("")

    const channel = params?.channel
    useEffect(() => {
        async function initPlayer() {
            const certificate = {
                widevine:  getServerEndPoint() + "drm/certs/widevine",
                fairplay: getServerEndPoint() + "drm/certs/fairplay",
            }
            const valide = await valideLogin()
            if (!valide) {
                window.location.href ="/"
            }

            let serverCertificate
            if(isWindowEdge()){
                serverCertificate = await fetchServerCertificate(certificate.fairplay)
            }
            else if(isSafari()){
                serverCertificate =  await fetchServerCertificate(certificate.fairplay)
            }
            else if(isPlayStationBrowser()){
                serverCertificate =  await fetchServerCertificate(certificate.fairplay)
            }
            else {
                serverCertificate = await fetchServerCertificate(certificate.widevine)
            }

            let events = await axios.get(getServerEndPoint() + "api/eventShow?channelId=" + channel)
            setEvents(events.data)
            let tokenLiveStorage = window.localStorage.getItem("LiveToken")

            if (!tokenLiveStorage) {
                return;
            }
            const userProfiles = {
                "liveToken": tokenLiveStorage,
                "userKeyId": "_w6z8z6bo6",
                "deviceKeyId": "1703081997682-750b3b2e2090"
            }
            setUserProfiles(userProfiles)

            let channelStorage = window.sessionStorage.getItem("Channels")
            let mdpUrlII

            if (channelStorage?.length > 0) {
                let channels = JSON.parse(channelStorage)
                if (channels?.length > 0) {
                    let foundChannels = channels?.filter((channel) => channel.EpgId === params?.channel)

                    if (foundChannels?.length > 0) {

                        const channelNow = foundChannels[0]
                        const logo = getLogoURL(channelNow.LogoUrl)
                        setChannelLogo(logo)
                        const rMUToken = window.localStorage.getItem("RMUToken")
                        const liveTokenUrl = channelNow?.WSXUrl.replace("{RMUToken}", rMUToken)
                        const response = await axios.get(liveTokenUrl)
                        //mdpUrlII = response?.data?.nodvr?.src
                        mdpUrlII= response?.data?.dvr?.src

                        if(!isSafari()){

                            //TODO WHY THIS HERE
                            let getChannelTokenId;
                            if(response?.data?.adswitched){
                                getChannelTokenId = await getChannelLocalTokenAdswitched(channel, 1, response?.data?.adswitched[0]?.src, channelNow.Name, response?.data?.dvr?.src)
                                mdpUrlII = getServerEndPoint() + "channel/api/dash_xml_url_ads?channelId=" + getChannelTokenId.data.id
                            }
                            else {
                                getChannelTokenId = await getChannelLocalToken(channel, 1, mdpUrlII, channelNow.Name)
                                mdpUrlII = getServerEndPoint() + "channel/api/dash_xml_url?channelId=" + getChannelTokenId.data.id

                            }
                            const licenceApiGetWay = await getLicence()
                            const configs = getConfigsDrm(serverCertificate, certificate, licenceApiGetWay)


                            setMdp(mdpUrlII)
                            setConfigs(configs)
                            setLoading(false)
                        }
                        else {
                            const getChannelTokenId = await getIsoChannelLocalToken(channel, 1, mdpUrlII, channelNow.Name)
                            mdpUrlII = getServerEndPoint() + "channel/api/m3u/" + getChannelTokenId.data?.channelId +"/transport?id=" + getChannelTokenId.data?.id
                            const licenceApiGetWay = await getLicence()
                            const configs = getConfigsDrm(serverCertificate, certificate, licenceApiGetWay)
                            setMdp(mdpUrlII)
                            setConfigs(configs)
                            setLoading(false)

                        }


                    }
                }

            }

        }
        initPlayer()
    }, [channel, params?.channel]);

    useEffect(() => {
        const interval = setInterval(async () => {
           const data = await userSessionChecker(userCode)
            if (!data.valid) {
                setIsBlocked(true);          // ← show blocked page
                clearInterval(interval);
            }
        }, 7000);

        return () => clearInterval(interval);
    }, []);



    if (isBlocked) return <ConnectionBlockedPage />;

    return <>

        {
            !loading ? <> <RunnerPlayer showDrawer ={showDrawer}
                                     paramsEpgId={channel}
                                     events ={events}
                                     mpdUrl={mdp}
                                     userProfile={userProfiles}
                                     setShowDrawer={setShowDrawer}
                                     channelLogo={channelLogo}
                                     config={configs}></RunnerPlayer>
                </> :
                <div style={{top :0, background:"black", height: "100vh", width: "100vw", display: "flex", padding:60, flexDirection:"column", justifyContent:"center" }}>
                    <SimpleBackdrop open={true}></SimpleBackdrop>
                </div>

        }


    </>

}
